var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrustWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24653_22551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37259 18.6274 0 12 0C5.37259 0 0 5.37259 0 12C0 18.6274 5.37259 24 12 24Z",
    fill: "#3375BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.525 4.67435C11.799 4.44188 12.1976 4.44188 12.4717 4.67435C14.4793 6.37721 16.7684 6.36405 17.6543 6.35895C17.6985 6.3587 17.7392 6.35846 17.7761 6.35846C17.9739 6.35846 18.1634 6.43904 18.3022 6.58215C18.441 6.72526 18.5175 6.91893 18.5145 7.11978C18.4726 9.94195 18.3612 11.9562 18.1427 13.4324C17.9242 14.9077 17.5893 15.9189 17.0496 16.6806C16.5061 17.4478 15.8076 17.8834 15.0637 18.3009C14.9348 18.3733 14.8034 18.4457 14.6689 18.5198C14.0159 18.8795 13.2902 19.2793 12.4287 19.9069C12.1715 20.0944 11.8252 20.0944 11.5679 19.9069C10.7073 19.2799 9.98245 18.8803 9.33052 18.5208C9.19535 18.4463 9.06331 18.3735 8.93385 18.3008C8.19059 17.8831 7.49297 17.4474 6.9505 16.68C6.412 15.9182 6.07824 14.9071 5.86063 13.432C5.64288 11.956 5.53201 9.94187 5.49007 7.11978C5.48709 6.91893 5.56356 6.72526 5.70236 6.58215C5.84115 6.43904 6.03067 6.35846 6.22845 6.35846C6.26503 6.35846 6.30532 6.3587 6.34912 6.35895C7.2278 6.36405 9.51719 6.37734 11.525 4.67435ZM6.98018 7.85378C7.02975 10.2592 7.13757 11.9647 7.32125 13.2098C7.52379 14.5827 7.80915 15.3226 8.15027 15.8052C8.48743 16.2822 8.92992 16.5843 9.6488 16.9882C9.76589 17.054 9.88938 17.122 10.0191 17.1935C10.572 17.498 11.2375 17.8645 11.9983 18.3844C12.7602 17.8638 13.4267 17.4971 13.9806 17.1923C14.1097 17.1212 14.2327 17.0535 14.3493 16.9881C15.0691 16.584 15.5127 16.2818 15.8508 15.8046C16.1927 15.3219 16.4789 14.582 16.6822 13.2094C16.8665 11.9645 16.9748 10.2591 17.0244 7.85392C15.8875 7.81669 13.8853 7.57824 11.9983 6.19873C10.1136 7.57659 8.11424 7.81611 6.98018 7.85378Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24653_22551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustWallet);
export default __webpack_public_path__ + "static/media/TrustWallet.1f2f3b31b0a65d49756b2571653fa4d7.svg";
export { ForwardRef as ReactComponent };